import { render, staticRenderFns } from "./WorkingGroupEventWin.vue?vue&type=template&id=4768b3bb"
import script from "./WorkingGroupEventWin.vue?vue&type=script&lang=js"
export * from "./WorkingGroupEventWin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports